import React from "react"

import Button from "../Button"

const Card = ({ size, price, color, title, options }) => {
  return (
    <div
      className={`relative ${
        size === "s" ? "md:bottom-[29px]" : ""
      } flex flex-col border-2 border-black px-9 w-full ${
        size === "s" ? "h-[413px]" : "h-[384px]"
      } mb-20 md:w-[49%] lg:mb-0 lg:w-[32.4%]`}
    >
      <h1 className="m-0 playfair flex relative bottom-[6%] self-center bg-bg px-6 font-playfair font-black text-[36px]">
        {price}
        <span className="text-[21px] self-end">$</span>
      </h1>
      <h3 className="font-playfair font-black text-[21px] text-black text-center mb-7">
        {title}
      </h3>

      <ul className="list-disc mb-12 font-light ml-4">
        {options.map(option => (
          <li
            className="font-ubuntu text-[14px] text-black m-0 mb-[3px] last:mb-0"
            key={option}
          >
            {option}
          </li>
        ))}
      </ul>

      <Button
        size={size}
        color={color}
        styles={`absolute bottom-[-4%] self-center bg-bg ${
          size === "s" ? "px-[28px]" : "px-[31px]"
        }`}
      >
        Order
      </Button>
    </div>
  )
}

export default Card
